import AddIcon from "@mui/icons-material/Add";
import {
    Dialog,
    Grid
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";
import DialogBody from "./Body";
import DialogActionButtons from "./Footer";
import DialogHeader from "./Header";
import Label from "../Label";
import TextInput from "../TextInputs";
import { addCustomVaraintValuesValidation } from "../../utils/Validation";
import { handleOpenSnackBar } from "../../utils";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing("24px"),
    },
    "& .MuiPaper-root": {
        width: "600px",
        [theme.breakpoints.down("sm")]: {
            margin: 12,
        },
    },
}));

let paramsData = {};

const initialInputValues = {
    label: "",
    value: "",
};

const AddCustomVaraintValues = forwardRef(({ onConfirm }, ref) => {
    const [open, setOpen] = useState(false);
    const { t } = useTranslation(["common"]);
    const [inputError, setInputError] = useState({});
    const [inputValues, setInputValues] = useState(initialInputValues);

    useImperativeHandle(ref, () => ({
        openDialog(params) {
            paramsData = params;
            setOpen(true);
        },

        closeDialog() {
            setOpen(false);
        },
    }));

    const handleClose = () => {
        setOpen(false);
        setInputValues(initialInputValues);
        setInputError({});
    };

    const handleChangeValues = (event) => {
        const { name, value } = event.target;
        setInputValues((prev) => ({ ...prev, [name]: value }));
        setInputError((prev) => ({ ...prev, [name]: "" }));
    };

    const handleSave = () => {
        const valid = addCustomVaraintValuesValidation(inputValues, setInputError);
        if (valid) return handleOpenSnackBar("error", t("resolveTheIssues"));

        const payload = {
            label: inputValues.label,
            value: inputValues.value,
        };

        onConfirm(paramsData.type, payload);
        handleClose();
    };

    return (
        <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open}
        >
            <DialogHeader
                title={t("addCustomVaraintValues")}
                secondaryHeading={t("addCustomVaraintValuesInstruction")}
                onClose={handleClose}
                icon={<AddIcon />}
            />
            <DialogBody>
                {
                    paramsData.type === "weight" && (
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Label labelText={t("label")} required htmlFor={"label"} />
                                <TextInput
                                    id={"label"}
                                    type={"text"}
                                    placeholder={t("enterLabel")}
                                    name={"label"}
                                    value={inputValues.label}
                                    onChange={handleChangeValues}
                                    inputError={Boolean(inputError.label)}
                                    helperText={t(inputError.label)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Label labelText={t("value")} required htmlFor={"value"} />
                                <TextInput
                                    id={"value"}
                                    type={"text"}
                                    placeholder={t("enterValue")}
                                    name={"value"}
                                    value={inputValues.value}
                                    onChange={handleChangeValues}
                                    inputError={Boolean(inputError.value)}
                                    helperText={t(inputError.value)}
                                />
                            </Grid>
                        </Grid>
                    )
                }

            </DialogBody>

            <DialogActionButtons
                onCancel={handleClose}
                onConfirm={handleSave}
                confirmText={t("add")}
                cancelText={t("cancel")}
                isConfirmBtnDisable={false}
                showCancelButton={true}
            />
        </BootstrapDialog>
    );
});

export default AddCustomVaraintValues;
